import React, { Component } from 'react'

class WordlistShareInfo extends Component {
  render() {
    const {
      authorName,
      enableCopy,
      onCopyClick,
    } = this.props
    return (
      <div className="bg-green-50 p-4 mb-4 text-sm">
        <p className='mb-4'>
          Det här är en delad lista skapad av{' '}
          <i>{authorName}</i>.
          {enableCopy
            ? ' Kopiera listan om du vill spara eller redigera den.'
            : null}
        </p>
        {enableCopy ? (
          <button
            className="btn-white inline-flex items-center leading-none center"
            type="button"
            onClick={onCopyClick}
          >
            <span className='mr-2'>+</span>
            <span>Kopiera till mina listor</span>
          </button>
        ) : null}
      </div>
    )
  }
}

export default WordlistShareInfo
